import React from 'react';
import { BottomNavigation, BottomNavigationAction, makeStyles } from '@material-ui/core';
import { navItems } from '.';
import { useHistory, useLocation } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'fixed',
    bottom: 0
  }
}));


function BottomNav(props) {
  const { business } = props;
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const page = location.pathname.split('/')[3];
  const path = page ? `/${page}` : '';

  return (
    <BottomNavigation
      value={path}
      onChange={(_, page) => history.push(`/business/${business.url || business.id}${page}`)}
      showLabels
      className={classes.root}
    >
      {navItems.map(item => (
        <BottomNavigationAction
          key={item[0]}
          label={item[0]}
          icon={item[2]}
          value={item[1]}
        />
      ))}
    </BottomNavigation>
  );
}

export default BottomNav;
